/* Link-only discovery rules, plus workplace decoration/cart quantity safeguards. */
(() => {
  const privateHandle='mcdonalds-workplace-essentials';
  function hidePrivateLinks(root=document) {
    root.querySelectorAll('a[href*="/collections/'+privateHandle+'"]:not([data-ace-private-hidden])').forEach(a=>{
      if(a.closest('ace-workplace')||a.closest('.cart-item'))return;
      a.dataset.acePrivateHidden='true';a.hidden=true;a.style.setProperty('display','none','important');
    });
    root.querySelectorAll('button:not([data-ace-private-hidden])').forEach(button=>{
      if(button.textContent.trim().replace(/[’']/g,'').toLowerCase()==='mcdonalds'){
        button.dataset.acePrivateHidden='true';button.hidden=true;button.style.setProperty('display','none','important');
      }
    });
  }
  hidePrivateLinks();let scheduled=false;
  new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;hidePrivateLinks();});}).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('click',event=>{
    const button=event.target.closest('button');
    if(button&&button.textContent.trim().replace(/[’']/g,'').toLowerCase()==='bobs truck'){
      event.preventDefault();event.stopImmediatePropagation();window.location.assign((window.Shopify?.routes?.root||'/')+'collections/bobstruck');
    }
  },true);
  const root=window.Shopify?.routes?.root||'/';
  const json=async(url,body)=>{const response=await fetch(url,body?{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}:{});const data=await response.json();if(!response.ok)throw new Error(data.description||'Your cart could not be updated. Please try again.');return data;};
  let pending=Promise.resolve();
  window.aceWorkplaceCartChange=(line,quantity,sections)=>{
    const task=pending.catch(()=>{}).then(async()=>{
      const cart=await json(root+'cart.js'), item=cart.items[Number(line)-1];
      if(!item?.properties?._ace_group)return json(root+'cart/change.js',{line:Number(line),quantity:Number(quantity),...sections});
      const group=item.properties._ace_group, parent=cart.items.find(i=>i.properties?._ace_group===group&&i.properties?._ace_role==='garment');
      if(!parent)throw new Error('This decoration is missing its garment. Please remove it and customize again.');
      // Validate garment stock with change.js before updating its decoration quantity.
      let updated=await json(root+'cart/change.js',{id:parent.key,quantity:Number(quantity)});
      const newParent=updated.items.find(i=>i.properties?._ace_group===group&&i.properties?._ace_role==='garment');
      const finalQty=newParent?.quantity||0,updates={};
      updated.items.filter(i=>i.properties?._ace_group===group&&i.properties?._ace_role==='decoration').forEach(i=>updates[i.key]=finalQty);
      return json(root+'cart/update.js',{updates,...sections});
    });
    pending=task;return task;
  };
  function validate(cart){
    const parents=cart.items.filter(i=>i.properties?._ace_role==='garment');
    for(const p of parents){
      let expected;try{expected=JSON.parse(p.properties._ace_expected);}catch{return false;}
      const children=cart.items.filter(i=>i.properties?._ace_group===p.properties._ace_group&&i.properties?._ace_role==='decoration');
      if(!Array.isArray(expected)||!expected.length||children.length!==expected.length)return false;
      if(!expected.every(id=>children.some(c=>c.variant_id===id&&c.quantity===p.quantity)))return false;
    }
    return !cart.items.some(c=>c.properties?._ace_role==='decoration'&&!parents.some(p=>p.properties._ace_group===c.properties._ace_group));
  }
  let checking=false;
  async function checkout(event){
    const target=event.target.closest('button[name="checkout"],input[name="checkout"],a[href$="/checkout"]');
    if(!target||!document.querySelector('[data-ace-role="garment"],[data-ace-role="decoration"]'))return;
    event.preventDefault();event.stopImmediatePropagation();if(checking)return;checking=true;
    try{await pending;const cart=await json(root+'cart.js');if(!validate(cart))throw new Error('A garment and its decoration no longer match. Remove that garment from your cart, then customize it again before checkout.');window.location.assign(root+'checkout');}
    catch(error){const el=document.querySelector('#cart-errors,#CartDrawer-CartErrors');if(el){el.setAttribute('role','alert');el.textContent=error.message;el.scrollIntoView({block:'center'});}else window.alert(error.message);checking=false;}
  }
  document.addEventListener('click',checkout,true);
})();
